<template>
  <div id="app">
    <login></login>
    <menutop></menutop>
    <div class="container-fluid" id="dvconteudoapp"> 
      <router-view></router-view>
    </div>      
  </div>
</template>
<style>
  #dvconteudoapp{
    margin-top: 70px;
    padding: 0px;
    /* margin-bottom: 15px; */
  }
  #dvcrud{
    margin-bottom: 15px;
  }
</style>
<script>

import menutop from './views/menutop.vue'
import login from './views/login'
import util from './utilitarios/util.js'

export default {
  name: 'app',
  components: {   
      'menutop' : menutop,
      'login'   : login
  },
  mounted:function(){    
  },
  methods:{
  },
  computed: {
  }
}
</script>
